import { Card, styled } from '@mui/material';

const ModalBody = styled(Card)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 600,
  width: 630,
  padding: '24px 20px',
  overflowY: 'auto',
  maxHeight: '98vh',
  borderRadius: '12px',
});

export default ModalBody;
